import { useBottomNavigator } from "utils/hooks/misc.tsx";
import React, {
  PropsWithChildren,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { PortfolioTab } from "@shared/types";
import { useRouteMatch } from "react-router-dom";
import { PORTFOLIO_POSITIONS_PATH } from "common/constants.ts";
import { useSelector } from "react-redux";
import { selectPortfolioDataLoadingStates } from "@shared/slices/portfolio.slice.ts";
import { PortfolioContext } from "features/portfolio/Portfolio.context.ts";
import useMedia from "utils/hooks/useMedia.ts";
import { PageWrapperContext } from "common/Home/PageWrapper/PageWrapper.context.tsx";

const PortfolioProvider = ({ children }: PropsWithChildren) => {
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();
  const isSmallScreen = useMedia([`(max-width: 1100px)`], [true], false);

  const { useMobileSearch, search } = useContext(PageWrapperContext)!;

  const [isCardsView, setIsCardsView] = useState(false);
  const [localSearchValue, setLocalSearchValue] = useState("");
  const [buyModalOpen, setBuyModalOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState(
    isBottomNavigator ? PortfolioTab.ACCOUNTS : PortfolioTab.ASSETS
  );
  const [tabToNumItems, setTabToNumItems] = useState<
    Record<PortfolioTab, number | undefined>
  >({
    [PortfolioTab.ASSETS]: undefined,
    [PortfolioTab.POSITIONS]: undefined,
    [PortfolioTab.ACCOUNTS]: undefined,
  });

  const isPositionsRoute = !!useRouteMatch(PORTFOLIO_POSITIONS_PATH);
  const isPositions = isBottomNavigator
    ? selectedTab === PortfolioTab.POSITIONS
    : isPositionsRoute;
  const { loading, loaded } = useSelector(selectPortfolioDataLoadingStates);

  useEffect(() => {
    if (isSmallScreen) {
      setIsCardsView(true);
    }
  }, [isSmallScreen]);

  const searchValue = useMobileSearch ? search.value : localSearchValue;

  const contextValue = useMemo(
    () => ({
      isPositions,
      isCardsView,
      setIsCardsView,
      searchValue,
      setSearchValue: setLocalSearchValue,
      buyModalOpen,
      setBuyModalOpen,
      loading,
      loaded,
      selectedTab,
      setSelectedTab,
      tabToNumItems,
      setTabToNumItems,
    }),
    [
      isPositions,
      isCardsView,
      searchValue,
      buyModalOpen,
      loading,
      loaded,
      selectedTab,
      tabToNumItems,
    ]
  );

  return (
    <PortfolioContext.Provider value={contextValue}>
      {children}
    </PortfolioContext.Provider>
  );
};

export default PortfolioProvider;
